/**
 * Created by fers on 26.09.15.
 */

import { v4 as uuidv4 } from 'uuid';
import { declareEntity } from '../fw/MetaDataHelper.ts';
// import {StoreStatus} from './StoreInfoType';

export default declareEntity({
    entity: "dataSets",
    graphQL: "DataSet",
    name: "Data Set",
    userEditable: false,
    storageType: 'central',
    parentRelation: "dataSets",
	defaultTitle: (data) => {
		let name = '';

		if (data['entityDef']) {
			name = data['entityDef']['pluralName'];

			if (!name) {
				name = data['entityDef']['name'];
			}
		}

		return name;
    },
    fields: (types) => { return {
        id: {
            name: "Data Set ID",
            type: "string",
            id: true,
            defaultValue: () => {
                return uuidv4();
            },
            required: true,
            primaryKey: true,
        },
        channel: {
            name: "Application",
            type: "relation",
            to: () => types['channels'],
            required: true,
            parent: true,
        },
        organisation: {
            name: "Organisation",
            type: "relation",
            to: () => types['organisations'],
            required: true,
        },
        channelEntityDef: {
            name: "Application Entity Definition",
            type: "relation",
            to: () => types['channelEntityDefs'],
            required: true,
            relativeTo: ['channelDef'],
        },
        entityDef: {
            name: "Entity Definition",
            type: "relation",
            to: () => types['entityDefs'],
            required: true
        },
        channelDef: {
            name: "Application Definition",
            type: "relation",
            to: () => types['channelDefs'],
            required: true
        },
        storeInfo: {
            name: "Store Info",
            type: "relation",
            to: () => types['storeInfos'],
            controllerFn: 'getStoreInfo',
            userEditable: false,
            import: false,
            export: false,
        },
        sourceDef: {
            name: "Source Definition",
            type: "relation",
            to: () => types['sourceDefs'],
            required: true,
            relativeTo: ['channelDef'],
        },
    }; },
    relations: (types) => { return {
        internalStoreInfos: {
            name: "Store Info",
            type: 'oneToMany',
            userVisible: false,
            to: types['storeInfos'],
            foreignKeys: [
                {
                    from: "channel_id",
                    to: "channel_id"
                },
                {
                    from: "channelEntityDef_id",
                    to: "channelEntityDef_id"
                },
                {
                    from: "organisation_id",
                    to: "organisation_id",
                    asFilterOnly: true,
                },
            ]
        },
        customDatas: {
            type: 'oneToMany',
            to: types['customDatas'],
            foreignKeys: [
                {
                    from: "organisation_id",
                    to: "organisation_id"
                },
                {
                    from: "channel_id",
                    to: "channel_id"
                },
                {
                    from: "sourceDef_id",
                    to: "sourceDef_id"
                }
            ]
        },
        viewsWithData: {
            type: 'oneToMany',
            controllerFn: 'getViewsWithData',
            to: types['viewWithData'],
        },
        viewWithData: {
            type: 'oneToMany',
            controllerFn: 'getViewsWithData',
            args: {
                key: {
                    type: "string"
                },
            },
            to: types['viewWithData'],
        }
    }; }
});
